module.exports = __webpack_public_path__ + "assets/img/icon-logo.7d3a7f62.png";